import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import PagedEntitiesGrid from '../../common/components/PagedEntitiesGrid';
import Card from '../../common/components/Card';
import { Image } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import FontAwesome from 'react-fontawesome';

const Grid = ({ t, ...rest }) => {
    const renderItem = item => {
        const { grade, center } = item.lesson;

        return <Card key={item.id} color='purple' style={{ marginBottom: 15 }}>
            <div>
                <span className='circle-icon bg-light' style={{ float: 'left', marginRight: 8, marginTop: -5, width: 55, height: 55, lineHeight: '55px', fontSize: 24 }}>
                    {grade && grade.imageUrl ? <Image src={grade.imageUrl} width={35} height={35} /> : <FontAwesome name='users' className='text-purple' />}
                </span>
                <div>
                    <h4>{center && center.name}</h4>
                    <h4 className='text-muted'>{t(`PaymentTypeEnum_${item.paymentType}`)}</h4>
                </div>
            </div>
            <div style={{ fontSize: 20, marginTop: 10, marginBottom: 10 }} className='grade-link'>{item.child && item.child.shortName}</div>
            <div style={{ position: 'relative' }}>
                <div className='text-muted'>
                    <div>{t('FO_Payment_Created')}</div>
                    <div>{moment(item.created).format('lll')}</div>
                </div>
                <div style={{ position: 'absolute', bottom: 0, right: 0 }}><Link to={`/enrolments/${item.id}`}>{t('FO_Payment_Details')}</Link></div>
            </div>
        </Card>;
    }

    return <PagedEntitiesGrid itemsPerRow={1} itemComponent={renderItem} {...rest} />;
};

Grid.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        child: PropTypes.shape({
            shortName: PropTypes.string
        }),
        center: PropTypes.shape({
            name: PropTypes.string
        }),
        startDate: PropTypes.string,
        created: PropTypes.string
    }))
};

export default withTranslation()(Grid);